import { useLeadStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useLeadNoteDelete = (): (leadId: number, noteId: number) => Promise<void> => {
    const leadStore = useLeadStore();

    return async (leadId: number, noteId: number): Promise<void> => {
        try {
            await leadStore.deleteLeadNote(leadId, noteId);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeadNoteDelete;
